<template>
  <div class="root_node">
    <div class="container">
      <div class="tc">
        <Header tln="project" v-slot:imgname><img src="../assets/banner/news.jpg" alt="" /></Header>
        <Content tln="news" :nds="newsDatas"></Content>
      </div>
      <Footer tln="four"></Footer>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import Header from "../components/common/Header";
  import Content from "../components/common/Content";
  import Footer from "../components/common/Footer";
  export default {
    name: 'News',
    data: function() {
      return {
        newsDatas: []
      }
    },
    mounted:function(){
      axios.get("/xy_api/home.php?page=news").then(res => {
        if(res.status == 200) {
          this.newsDatas = res.data.newsDatas;console.log(this.newsDatas);
        }
      }).catch(err => {
        console.log(err);
      })
    },
    components: { Header, Content, Footer }
  }
</script>

<style type="text/less" lang="less">
  @import url("../assets/css/base.less");
</style>



// WEBPACK FOOTER //
// src/components/News.vue